





































































































import CheckoutReviewOrderItemViewModel from "@/chipply/view-model/CheckoutReviewOrderItemViewModel";
import Component from "vue-class-component";
import Vue from "vue";
import { Prop } from "vue-property-decorator";
import { Utils } from "chipply-common";
import PriceDisplay from "./price/PriceDisplay.vue";

@Component({
    components: { PriceDisplay },
})
export default class OrderItemDisplay extends Vue {
    public name = "OrderItemDisplay";
    public Utils = Utils;

    @Prop({ default: false })
    public isRequestor!: boolean;

    @Prop({ default: {} })
    public item!: CheckoutReviewOrderItemViewModel;

    public valueDisplayFunc = (priceArgs: number) => Utils.getCurrencyValue(priceArgs, false, true);

    public get displaySize() {
        const size = this.item.sizes.find((x) => x.sizeId == this.item.selectedSize);
        return size ? `Size: ${size.sizeName}` : "";
    }

    public get displayColor() {
        const color = this.item.colors.find((x) => x.colorId == this.item.selectedColor);
        return color ? `${color.colorName}` : "";
    }

    public get displayColorCode() {
        const color = this.item.colors.find((x) => x.colorId == this.item.selectedColor);
        return color ? `${color.colorCode}` : "";
    }

    public get mobile() {
        return this.$vuetify.breakpoint.smAndDown;
    }
}
